import { BusinessDetails } from '../../slices/businessDetails';
import { RiskLocation } from '../../types/policy';

export const getBusinessLocation = ({
  businessDetails: { fullBusinessAddress, addressLine1, suburb, state, postcode },
}: {
  businessDetails: Partial<BusinessDetails>;
}): RiskLocation => ({
  partnerId: 'Loc1',
  situationNumber: '',
  situationTurnover: 0,
  addressLine1: (fullBusinessAddress ? fullBusinessAddress?.streetAddress1 : addressLine1) ?? '',
  city: (fullBusinessAddress ? fullBusinessAddress?.city : suburb) ?? '',
  stateCode: (fullBusinessAddress ? fullBusinessAddress?.stateCode : state) ?? '',
  postalCode: (fullBusinessAddress ? fullBusinessAddress?.postalCode : postcode) ?? '',
});
